import { Component, ChangeDetectionStrategy, ChangeDetectorRef, OnInit } from '@angular/core';
import { BbAbstractMenuComponent } from '../shared/bb-abstract-menu/bb-abstract-menu.component';
import { RouterEvent, NavigationEnd } from '@angular/router';


@Component({
	selector: 'bb-library-menu',
	templateUrl: './bb-library-menu.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})

export class BbLibraryMenuComponent extends BbAbstractMenuComponent implements OnInit {

	constructor(
		private changeDetector: ChangeDetectorRef
	) {
		super(['channel', 'mediaclip', 'project', 'placement', 'playout', 'playlist', 'upload-transcode', 'template', 'datafeed', 'lineup']);
	}

	ngOnInit() {
		this.subscriptions.add(this.router.events.subscribe((routerEvent: RouterEvent) => {
			if (routerEvent instanceof NavigationEnd) {
				this.changeDetector.detectChanges();
			}
		}));
	}
}
